import React, {useContext, useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {useNavigate} from "react-router";
import {PageContext} from "@lb/mlib-components";

const Page = ({noPadding, padding = 2, marginTop = 2, goBack, goBackTitle='', children}) => {

    const navigate = useNavigate();
    const [currentURL, setCurrentURL] = useState(window.location.pathname);
    const pageCtx = useContext(PageContext);

    useEffect(() => {
        setCurrentURL(window.location.pathname);
    }, [window.location.pathname]);

    return (
        <Box
            sx={{
                padding: noPadding ? 0 : padding,
                paddingTop: noPadding ? 0 : marginTop
            }}>
            {goBack && (
                <Button
                    size="large"
                    sx={{paddingLeft: 0}}
                    startIcon={<ChevronLeftIcon size="small" fontSize="80%"/>}
                    onClick={() => navigate(currentURL.replace(/\/[^/]+$/, ''))}
                >
                    {goBackTitle || pageCtx.title.split('|')[pageCtx.title.split('|').length - 1]}
                </Button>
            )}
            {children}
        </Box>
    );
}

export default Page;